import React from 'react';

import { Link } from 'react-router-dom';

import './style.scss';
import 'firebase/auth';

export default function Terms() {
    return (
        <html id='termsPage'>
            <body id='termsInfos'>
                <h1>Termos de uso e condições legais</h1>

                <p>Data de atualização: 25 de março de 2022</p>

                <article>
                    <h2>1. Geral</h2>

                    <p>
                        O presente documento tem por objeto estabelecer as
                        Condições Gerais de Uso do site Cactus Sketchbooks na
                        Internet na cidade de São Luís, Estado do Maranhão,
                        situada na Rua da Inveja - n° 488 A - Centro, CEP
                        65015-180.
                    </p>

                    <p>
                        A finalidade da Cactus é a de disponibilizar uma
                        plataforma que permite a compra e o fornecimento de
                        informações dos sketchbooks comercializados pela Cactus.
                        Nesse sentido, permite aos usuários a compra e a
                        personalização dos produtos. Além disso, a plataforma é
                        utilizada para a divulgação dos trabalhos realizados
                        pelos artistas e criativos que utilizam dos produtos da
                        Cactus.
                    </p>

                    <p>
                        Os criadores e colaboradores do site poderão a seu
                        exclusivo critério e em qualquer tempo, modificar ou
                        desativar o site, bem como limitar, cancelar ou
                        suspender seu uso ou o acesso. Também estes Termos de
                        Uso poderão ser alterados a qualquer tempo.
                    </p>
                </article>

                <article>
                    <h2>2. Condições legais para Usuários</h2>

                    <p>
                        O site entende por Usuários, os usuários pessoas físicas
                        que utilizem a plataforma para fins de compra, ou
                        análise dos materiais dispostos no mesmo.
                    </p>

                    <p>
                        Nesse sentido, o site tem como objetivo disponibilizar
                        ao Usuário a compra dos nossos sketchbooks
                        personalizados de acordo com as escolhas de
                        personalização do mesmo. Além de mostrar o uso dos
                        mesmos pelos artistas e criativos que utilizam dos
                        nossos produtos.
                    </p>

                    <p>
                        A utilização por parte do Usuário de qualquer dos
                        Serviços do site supõe e expressa sua adesão e aceitação
                        expressa a todas as Condições Gerais de Uso na versão
                        publicada no presente site no momento em que o usuário
                        acesse a Cactus.
                    </p>

                    <h3>2.1 Responsabilidades</h3>

                    <p>
                        O site apenas e tão somente responde pelos serviços
                        próprios e conteúdos diretamente originados por ele
                        mesmo.
                    </p>

                    <p>
                        O site não se responsabiliza nem respalda em nenhum
                        caso, os produtos ou serviços prestados ou ofertados
                        pelo cliente ou por terceiras pessoas ou entidades por
                        meio de se seus serviços, tampouco por conteúdo,
                        informação, comunicação, opinião ou manifestação de
                        qualquer tipo que tenha o cliente ou terceiras pessoas
                        ou entidades e que comuniquem, transmitam ou exponham
                        através de nossos serviços.
                    </p>

                    <p>
                        O site poderá eliminar conteúdos ilegais ou supostamente
                        ilegais sem prévio aviso.
                    </p>

                    <p>
                        O Usuário reconhece que tecnicamente não é possível
                        obter uma disponibilidade do site a 100% (cem por
                        cento). Entretanto, o site se esforçará para manter
                        disponível a Cactus da forma mais constante possível.
                        Especialmente por razões de manutenção, segurança ou
                        capacidade, bem como, em razão de acontecimentos sobre
                        os quais não possa interferir o site (por exemplo:
                        anomalias de redes públicas de comunicação, cortes de
                        eletricidade, etc.), podem produzir breves anomalias ou
                        a suspensão passageira dos serviços da Cactus.
                    </p>

                    <h3>2.2 Serviços da Cactus</h3>

                    <p>Enumeram-se os serviços que o site presta ao Usuário:</p>

                    <ul>
                        <li>
                            1. Inscrição do Usuário de forma gratuita no sistema
                            da Cactus através do processo de cadastramento de
                            perfil, para a compra de nossos produtos;
                        </li>

                        <li>
                            2. Divulgação dos artistas e artes confeccionadas
                            através de um sketchbook criado pela Cactus na
                            página <i>Use e Apareça</i>;
                        </li>

                        <li>
                            3. Formulário para contato, retirada de dúvidas e
                            demais funções supridas pelo mesmo;
                        </li>

                        <li>
                            4. Fornecimento das informações referentes aos
                            diferentes modelos de sketchbooks oferecidos pela
                            Cactus, como por exemplo: tamanhos, tipos de papel,
                            uso recomendando, etc;
                        </li>

                        <li>
                            5. Outros serviços que a Cactus possa criar que
                            considere de interesse para os Usuários.
                        </li>
                    </ul>

                    <h3>2.3 Obrigações do Usuário</h3>

                    <p>
                        O Usuário se compromete a fazer um uso lícito e
                        diligente do site e dos serviços acessíveis a partir do
                        mesmo, com total sujeição à norma vigente, aos bons
                        costumes e às presentes Condições Legais e, em seu caso,
                        condições particulares, assim como manter o devido
                        respeito aos demais usuários e equipe da Cactus.
                    </p>

                    <p>
                        O Usuário deve selecionar o identificador (e-mail) e a
                        senha comprometendo-se a conservá-la e utilizá-la com o
                        devido cuidado.
                    </p>

                    <p>
                        O uso da senha é pessoal e intransferível, não estando
                        permitida a cessão, nem sequer temporária, a terceiros.
                        Nesse sentido, o Usuário deverá adotar as medidas
                        necessárias para a guarda e custódia da senha por ele
                        selecionada, evitando o uso da mesma por terceiros. Em
                        consequência, o Usuário é o único responsável pela
                        utilização que, de sua senha realize, com completa
                        isenção para Cactus. Supondo que o Usuário conheça ou
                        suspeite do uso de sua senha por terceiros deverá levar
                        tal circunstância ao conhecimento do site com a maior
                        brevidade possível.
                    </p>

                    <p>
                        Toda a informação que disponibilizar o Usuário através
                        dos serviços deverá ser verdadeira. Para esses efeitos,
                        o Usuário garante a autenticidade de todos aqueles dados
                        que comunique como consequência do preenchimento dos
                        formulários para a assinatura dos Serviços.
                    </p>

                    <p>
                        De igual forma, será de responsabilidade do Usuário
                        manter toda a informação disponibilizada ao site
                        permanentemente atualizada, de modo que corresponda em
                        cada momento, à situação real do Usuário. Em todo e
                        qualquer caso o Usuário será o único responsável pelas
                        manifestações falsas ou inexatas que realize e pelos
                        prejuízos que causar ao site ou a terceiros pela
                        informação que disponibilizar.
                    </p>

                    <p>
                        O Usuário se obriga a respeitar as leis aplicáveis e os
                        direitos de terceiros ao utilizar os conteúdos e
                        serviços do site. Portanto, fica proibida a reprodução,
                        distribuição, transmissão, adaptação ou modificação, por
                        qualquer meio e em qualquer forma, dos conteúdos do site
                        (textos, desenhos, gráficos, informações, bases de
                        dados, arquivos de som e/ou imagem, logos, etc.) e
                        demais elementos desse site, salvo autorização prévia de
                        seus legítimos titulares ou quando assim seja permitido
                        pela lei.
                    </p>

                    <h3>
                        2.4 Não são permitidas ao Usuário as seguintes ações:
                    </h3>

                    <ul>
                        <li>
                            1. Utilizar mecanismos, software, scripts ou bugs em
                            relação à utilização do site que permitam ao usuário
                            tirar proveito de alguma funcionalidade do site.
                        </li>

                        <li>
                            2. Difundir, reproduzir ou comunicar publicamente
                            conteúdos da Cactus, de Usuários ou terceiros, sem a
                            autorização prévia do titular dos direitos.
                        </li>

                        <li>
                            3. Toda ação apta a prejudicar a funcionalidade da
                            ferramenta da infra-estrutura da Cactus,
                            especialmente para sobrecarregá-la.
                        </li>

                        <li>
                            4. Utilizar quaisquer dos materiais e informações
                            contidos neste site com fins ilícitos e
                            expressamente proibidos nas presentes Condições
                            Legais, bem como, as das condições particulares que,
                            em seu caso, se habilitem a que sejam contrários aos
                            direitos e interesses da Cactus, seus membros e/ou
                            terceiros, e deverá responder frente aos mesmos em
                            caso de violar ou deixar de cumprir respectivas
                            obrigações e/ou que, de qualquer modo (incluída a
                            introdução ou difusão de "vírus informáticos"),
                            cause dano, inutilize, sobrecarregue, deteriore ou
                            impeça a normal utilização dos materiais e
                            informações contidos no site, os sistemas de
                            informação ou os documentos, arquivos e toda classe
                            de conteúdos armazenados em qualquer equipamento
                            informático (hacking) da Cactus, de seus membros ou
                            qualquer usuário.
                        </li>
                    </ul>

                    <p>
                        O Usuário que descumprir de forma intencional ou
                        culpável qualquer das precedentes obrigações responderá
                        por todos os danos e prejuízos causados.
                    </p>

                    <h3>2.5 Privacidade Geral</h3>

                    <p>
                        A privacidade e a proteção dos dados do Usuário estão
                        descritas na{' '}
                        <Link
                            to='/politicaDePrivacidade'
                            target='_blank'
                            rel='noreferrer'
                        >
                            Política de Privacidade
                        </Link>{' '}
                        da Cactus, com a qual o Usuário declara ter lido e
                        aceito seus termos ao clicar para prosseguir com seu
                        cadastro.
                    </p>
                </article>

                <article>
                    <h2>3. Condições legais para empresas</h2>

                    <h3>3.1. Direito de informação</h3>

                    <p>
                        Se o usuário decide cadastrar-se na Cactus, serão
                        solicitados os dados estritamente necessários para que
                        se possa alcançar os fins e finalidades aos quais está
                        destinado o site.
                    </p>

                    <p>
                        Para poder cadastrar o usuário, este deverá completar um
                        formulário eletrônico inicial, o qual implica fornecer
                        dados de caráter pessoal. Os dados recolhidos nesse
                        formulário são os adequados, pertinentes e não
                        excessivos em relação com o âmbito, as finalidades e
                        serviços determinados, explícitos e legítimos da Cactus.
                    </p>

                    <h3>
                        3.2. Finalidade do recolhimento e tratamento dos dados
                        pessoais
                    </h3>

                    <p>
                        As finalidades do recolhimento e tratamento dos dados
                        pessoais fornecidos pelo usuário são as seguintes:
                    </p>
                </article>

                <article>
                    <h2>4. Gestão dos usuários</h2>

                    <p>
                        Prestação dos serviços da Cactus a clientes, que inclui
                        o seguinte:
                    </p>

                    <ul>
                        <li>
                            1. Recebimento de contato referente a uma compra
                            feita pela plataforma
                        </li>
                        <li>
                            2. Uso de informações de endereço para realização de
                            entregas por frete
                        </li>
                        <li>
                            3. Retorno por conta de uma mensagem enviada no
                            formulário de contato
                        </li>
                        <li>
                            4. Contato por conta de possíveis problemas ou
                            necessidades por parte da Cactus
                        </li>
                    </ul>

                    <h3>4.1 Responsabilidades</h3>

                    <p>
                        O usuário garante ao site que toda a informação de
                        caráter pessoal e empresarial que informe é exata e
                        atualizada, de modo que responda com veracidade à
                        situação atual do usuário e da empresa. Corresponde e é
                        obrigação do usuário manter em todo momento, seus dados
                        atualizados, sendo o usuário o único responsável pela
                        exatidão ou falsidade dos dados fornecidos ao site, e
                        pelos prejuízos que possa vir a causar ao site ou a
                        terceiros, decorrentes da utilização dos serviços
                        oferecidos pela Cactus.
                    </p>

                    <h3>4.2 Ainda está com alguma dúvida?</h3>

                    <p>
                        Envie uma mensagem através do nosso formulário de
                        contato ou por nossas outras plataformas oficiais e
                        ficaremos felizes de responder todas elas.
                    </p>
                </article>
            </body>
        </html>
    );
}
